"use client";

import { createContext, useContext, type ReactNode } from "react";
import type { SiteContent } from "@/content/schema";

const ContentContext = createContext<SiteContent | null>(null);

export function ContentProvider({
  content,
  children,
}: {
  content: SiteContent;
  children: ReactNode;
}) {
  return (
    <ContentContext.Provider value={content}>{children}</ContentContext.Provider>
  );
}

export function useContent(): SiteContent {
  const value = useContext(ContentContext);
  if (!value) {
    throw new Error("useContent must be used within ContentProvider");
  }
  return value;
}
